import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../../Common";
import { TableContentWithoutEdit } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { DailyCheckRoleSummarySchema } from "../DailyCheckRoleSummaryScehma";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createPdf";
import "../../../Common/Table/table.css";
import xlsx from "json-as-xlsx";
//import './printScale.css';
import _ from "lodash";

const screenCode = "DAILYCHECKROLESUMMARYREPORT";

export function DailyCheckRoleSummaryReport(props) {
  const componentRef = useRef();

  const [groups, setGroups] = useState([]);
  const [estates, setEstates] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [isTableHide, setIsTableHide] = useState(true);
  const [totalKg, setTotalKg] = useState([]);

  const [checkRoleSummaryReportData, setCheckRoleSummaryReportData] = useState({
    groupID: "0",
    estateID: "0",
    divisionID: "0",
    pluckingType: "0",
    searchDate: "",
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    group: "0",
    estate: "0",
    division: "0",
    pluckingType: "0",
    searchDate: "",
  });
  const [csvData, setCsvData] = useState([]);

  const [errors, setErrors] = useState({});

  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
  const [buttonHide, setButtonHide] = useState(true);
  const [reportData, setReportData] = useState([]);

  const schema = Joi.object(DailyCheckRoleSummarySchema).options({
    allowUnknown: true,
  });
  const contentRowNames = [
    "epfNo",
    "registrationNumber",
    "empName",
    "fieldName",
    "checkRoleTotal",
    "extraKg",
    "total",
  ];
  const csvHeaders = [
    { label: "EPF Number", value: "epfNo" },
    { label: "Registration Number", value: "registrationNumber" },
    { label: "Emp Name", value: "empName" },
    { label: "Field Name", value: "fieldName" },
    { label: "Check Role Total", value: "checkRoleTotal" },
    { label: "Extra Kg", value: "extraKg" },
    { label: "Total", value: "total" },
  ];
  const [keys, setKeys] = useState([]);

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getEstatesForDropdown());
  }, [checkRoleSummaryReportData.groupID]);

  useEffect(() => {
    trackPromise(getDivisionsForDropDown());
  }, [checkRoleSummaryReportData.estateID]);


  useEffect(() => { }, [reportData]);

  function handleGroupChange(target) {
    validateInputs(target);

    setCheckRoleSummaryReportData({
      ...checkRoleSummaryReportData,
      groupID: target.value,
      estateID: "0",
      divisionID: "0",
    });
  }

  function handleEstateChange(target) {
    validateInputs(target);

    setCheckRoleSummaryReportData({
      ...checkRoleSummaryReportData,
      estateID: target.value,
      divisionID: "0",
    });
  }

  function handleDivisionChange(target) {
    validateInputs(target);

    setCheckRoleSummaryReportData({
      ...checkRoleSummaryReportData,
      divisionID: target.value,
    });
  }

  function handleSearchDateChange(target) {
    validateInputs(target);

    setCheckRoleSummaryReportData({
      ...checkRoleSummaryReportData,
      searchDate: target.value,
    });
  }

  function handleChange(e) {
    e.preventDefault();

    const target = e.target;
    const value = target.value;

    const error = { ...errors };
    const errorMessage = validateProperty(target, DailyCheckRoleSummarySchema);
    errorMessage ? error[target.name] = errorMessage : delete error[target.name];

    setCheckRoleSummaryReportData({
        ...checkRoleSummaryReportData,
        [e.target.name]: value
    });

    setErrors(error);
}

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, DailyCheckRoleSummarySchema);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWDAILYCHECKROLESUMMARYREPORT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();

    setCheckRoleSummaryReportData({
      ...checkRoleSummaryReportData,
      groupID: token.groupID,
      estateID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropdown());
  }

  function destroyDataTable() {
    keys.forEach((e) => {
      $(`#${e}`).DataTable().destroy();
    });
  }

  function createDataTable() {
    keys.forEach((e) => {
      $(`#${e}`).DataTable();
    });
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getEstatesForDropdown() {
    const data = await services.getEstatesByGroupID(
      checkRoleSummaryReportData.groupID
    );
    setEstates(data);
  }

  async function getDivisionsForDropDown() {
    const data = await services.getDivisionByEstateID(
      checkRoleSummaryReportData.estateID
    );
    setDivisions(data);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function handleSearch(e) {
    e.preventDefault();
    var totalAmount = 0;
    var allTotal = 0;

    setButtonHide(true);

    const errorMessages = validate(schema, checkRoleSummaryReportData);

    errorMessages !== null ? setErrors(errorMessages) : setErrors({});

    if (errorMessages) return;

    getSelectedDropdownValuesForReport(checkRoleSummaryReportData);


    const result = await services.getDailyCheckRoleSummaryReport(
      checkRoleSummaryReportData
    );

    var dataModel = result.dataModel;
    var formatModel = result.formatModel;

    dataModel.forEach(x => {

      x.total = x.checkRoleTotal + x.extraKg;

    });

    setReportData(formatModel);



    formatModel.forEach((x) => {
      const rList = x.reportList;
      var checkRoleTotalAmount = 0;
      var extraKgTotalAmount = 0;

      rList.forEach((x) => {

        checkRoleTotalAmount = checkRoleTotalAmount + x.checkRoleTotal;
        extraKgTotalAmount = extraKgTotalAmount + x.extraKg;
      });
      x.allTotal = extraKgTotalAmount + checkRoleTotalAmount;
      return
    });

    if (formatModel.length > 0) {
      setIsTableHide(false);
      setIsReportButtonsEnabled(true);
    }
    setButtonHide(false);
    setIsReportButtonsEnabled();

    //const comlpeteData = [...result];
    setCsvData(dataModel);
  }

  function createFile() {
    var settings = {
      sheetName: "Daily Check Role Summary Report",
      fileName: "DailyCheckRoleSummaryReport",
      writeOptions: {},
    };
    var copyOfCsv = _.cloneDeep(csvData);
    var newRow1 = {
      epfNo: "Group :" + groups[checkRoleSummaryReportData.groupID],
      registrationNumber: "Estate : " + estates[checkRoleSummaryReportData.estateID],
      empName: "Division : " + divisions[checkRoleSummaryReportData.divisionID],
      fieldName: "Plucking Type : " + checkRoleSummaryReportData.pluckingType,
      checkRoleTotal: "Date : " + checkRoleSummaryReportData.searchDate,
      extraKg: "Generated date/time : " + new Date().toLocaleString(),
      total: "Generated user : " + tokenService.getUserNameFromToken(),
      
    };
    copyOfCsv.push({}, {}, newRow1);
    xlsx(csvHeaders, copyOfCsv, settings, true);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      group: groups[searchForm.groupID],
      estate: estates[searchForm.estateID],
      division: divisions[searchForm.divisionID],
      pluckingType: searchForm.pluckingType,
      date: searchForm.searchDate,
    });
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Daily Check Role Summary Report"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={checkRoleSummaryReportData.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="estateID">
                      Estate *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="estateID"
                      id="estateID"
                      name="estateID"
                      value={checkRoleSummaryReportData.estateID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleEstateChange(e.target)}
                    >
                      <MenuItem value="0">--Select Estate--</MenuItem>
                      {generateDropDownMenu(estates)}
                    </Select>
                    {errors["estateID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["estateID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="">
                      Division *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="divisionID"
                      id="divisionID"
                      name="divisionID"
                      value={checkRoleSummaryReportData.divisionID}
                      onChange={(e) => handleDivisionChange(e.target)}
                    >
                      <MenuItem value="0">--Select Division--</MenuItem>
                      {generateDropDownMenu(divisions)}
                    </Select>
                    {errors["divisionID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["divisionID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md">
                    <InputLabel shrink id="pluckingType">Plucking Type *</InputLabel>
                    <Select
                      id="pluckingType"
                      select
                      fullWidth
                      name="pluckingType"
                      onChange={(e) => handleChange(e)}
                      value={checkRoleSummaryReportData.pluckingType}>
                      <MenuItem value="0">--Select Plucking Type--</MenuItem>
                      <MenuItem value="GENERAL">General</MenuItem>
                      <MenuItem value="RSM">RSM</MenuItem>
                      <MenuItem value="CASH">Cash</MenuItem>
                      <MenuItem value="KILO">Kilo</MenuItem>
                    </Select>
                    {errors["pluckingType"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["pluckingType"]}</FormHelperText>)}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="searchDate">
                      Date *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="searchDate"
                      name="searchDate"
                      type="date"
                      onChange={(e) => handleSearchDateChange(e.target)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["searchDate"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["searchDate"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>

                <div className="card-footer">
                  <input
                    type="button"
                    className="btn btn-primary"
                    value="Search"
                    onClick={(e) => trackPromise(handleSearch(e))}
                  />
                </div>
              </form>

              {isTableHide ? null : (
                <div>
                  <div className="table-responsive row-top-gap">
                    <div className="card shadow-none bg-light">
                      <div className="row alternative_cls bg-light  ">
                        <div className="card-body width4">
                          <table className="display dataTable no-footer">
                            <thead>
                              <tr>
                                <th>EPF Number</th>
                                <th>Registration Number</th>
                                <th>Emp Name</th>
                                <th>Field Name</th>
                                <th>Check Role Total</th>
                                <th>Extra Kg</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reportData != null || reportData.length != 0
                                ? reportData.map((item) => (
                                  <>
                                    {item.reportList.map((detail, index) => (
                                      <tr>
                                        {index == 0 ? (
                                          <>
                                            <td
                                              rowSpan={item.reportList.length}
                                            >
                                              {item.epfNo}
                                            </td>
                                            <td
                                              rowSpan={item.reportList.length}
                                            >
                                              {item.registrationNumber}
                                            </td>
                                            <td
                                              rowSpan={item.reportList.length}
                                            >
                                              {item.empName}
                                            </td>
                                          </>
                                        ) : null}
                                        <td> {detail.fieldName}</td>
                                        <td>{detail.checkRoleTotal}</td>
                                        <td>{detail.extraKg}</td>
                                        {index == 0 ? (
                                          <td
                                            rowSpan={item.reportList.length}
                                          >
                                            {item.allTotal}
                                          </td>
                                        ) : null}
                                      </tr>
                                    ))}
                                  </>
                                ))
                                : null}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="pt-2">
                    <input
                      type="button"
                      className="btn btn-primary pull-right ml-2"
                      value="Excel"
                      onClick={createFile}
                    />
                    <ReactToPrint
                      documentTitle={"Daily Check Role Summary Report"}
                      trigger={() => (
                        <input
                          type="submit"
                          className="btn btn-primary pull-right ml-2"
                          value="PDF"
                        />
                      )}
                      content={() => componentRef.current}
                    />
                  </div>
                  <div hidden={true}>
                    <CreatePdf
                      ref={componentRef}
                      data={reportData}
                      rowNames={contentRowNames}
                      searchData={selectedSearchValues}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
